// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#page_nav_collapse>:first-child{width:100%}", "",{"version":3,"sources":["webpack://./resources/js/components/LayoutTwoColumn.vue"],"names":[],"mappings":"AACA,gCACC,UAAD","sourcesContent":["\r\n#page_nav_collapse > :first-child {\r\n\twidth: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
